module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/promocao/promocao.component.css
// module id = ./src/app/promocao/promocao.component.css
// module chunks = main